@if (data$ | async; as component) {
  <div class="container collections" [style]="'background-color :'+ component.background">
    <div class="h2-component">{{component.title}}</div>
    <cx-carousel
      [items]="items$ | async "
      [template]="collections"
      itemWidth="300px"
      [animation]="animation"
      >
    </cx-carousel>
  </div>
}


<ng-template #collections let-item="item">
  <a [href]="item.urlLink.url">
    <cx-media [container]="item.image"></cx-media>
    <h3 class="h3-component">{{item.title}}</h3>
    <p>{{item.description}}</p>
    <span class="text-uppercase text-underline font-gotham-light">{{item.buttonText}}</span></a>
  </ng-template>
